import { fg } from '@atlaskit/platform-feature-flags';

import { Edition, Product } from '../types';

import { getChargeElementKey } from './get-charge-element-key';
import { getJiraApplicationKey } from './get-jira-application-key';
import { getHamsKey } from './product-to-hams-key';

/**
 * Returns the variables required for the root Edition Awareness query.
 */
export function getQueryConfig(
	product: Product,
	edition: Edition,
	cloudId: string,
	accountId?: string | null,
) {
	const isStandardTrialsUserAndStorageLimitBreakersEnabledJira =
		product === 'jira' &&
		edition === 'standard' &&
		fg('jira_edition_awareness_standard_trials_gate');
	const isStandardTrialsUserAndStorageLimitBreakersEnabledConnie =
		product === 'confluence' &&
		edition === 'standard' &&
		fg('connie_edition_awareness_standard_trials_gate');
	const isStandardTrialsUserAndStorageLimitBreakersEnabled =
		isStandardTrialsUserAndStorageLimitBreakersEnabledJira ||
		isStandardTrialsUserAndStorageLimitBreakersEnabledConnie;

	return {
		shouldSkip: product === 'jira-product-discovery' && fg('jpd_disable_edition_awareness'),
		shouldCheckForChangeOffering: edition === 'free',
		shouldCheckForTrial: edition === 'premium' || edition === 'standard',
		cloudId,
		productKey: getHamsKey(product),
		shouldCheckForChargeQuantities:
			edition === 'free' || isStandardTrialsUserAndStorageLimitBreakersEnabled,
		// The entitlement filter ensures that we apply the `inTrialOrPreDunning` only when an entitlement is
		// on a non free edition. The filter is based on the trial end timestamp inside of TCS, this means that
		// if a customer downgrades their product to free while on a trial, then they will only show up
		// if inTrialOrPreDunning is set to true as the filter assumes they are still on trial.
		entitlementFilter: edition !== 'free' ? { inTrialOrPreDunning: true } : null,
		chargeElement: getChargeElementKey(product),
		shouldCheckBillingAdmin: false,
		shouldCheckForTwc:
			(product === 'jira' || product === 'confluence') && fg('teamwork_collection_ea_modal'),
		shouldCheckForStorageUsageJira: isStandardTrialsUserAndStorageLimitBreakersEnabledJira,
		applicationKey: getJiraApplicationKey(product) ?? 'JIRA_SOFTWARE',
		shouldCheckForStorageUsageConfluence: isStandardTrialsUserAndStorageLimitBreakersEnabledConnie,
		// AccountID is a required value, but the condition will ensure it is not used if undefined/null
		accountId: accountId ?? '',
		shouldCheckForUserEmail: !!accountId && product === 'jira' && edition === 'standard',
	};
}
